import { useCallback } from 'react';
import { DealMessageSlots } from './types';

export const useSlotsRenderer = (slots?: Partial<DealMessageSlots>) => {
  const slotsRenderer = useCallback((slotKey: keyof DealMessageSlots) => slots?.[slotKey]?.(), [slots]);
  return slotsRenderer;
};
